import React from 'react';

class PhotoThumbnailView extends React.PureComponent {

    constructor(props) {

        super(props);

        this.handleFullScreenClick = this.handleFullScreenClick.bind(this);
    }

    handleFullScreenClick() {

        if (this.props.onFullScreen)
            this.props.onFullScreen();
    }

    render() {

        return (

            <div className={`photo-thumbnail-view ${this.props.className || ''}`}>

                <img src={this.props.photo.filename} alt="thumbnail" className="img-thumbnail"/>

                {this.props.showControls && (

                    <div className="photo-thumbnail-controls btn-toolbar">
                        <div className="btn-group">
                            <button type="button" className="btn btn-dark" onClick={this.handleFullScreenClick}><i className="fas fa-search-plus"/></button>
                        </div>
                    </div>
                )}

            </div>
        );
    }
}

export default PhotoThumbnailView;



// WEBPACK FOOTER //
// ./src/components/PhotoThumbnailView.js